import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import Logo from 'containers/Logo';
import { LoaderButton } from 'ctia-ui';
import QuickSearch from 'components/QuickSearch';
import { createMemberLoginLink } from 'helpers/FormHelper';

class Home extends Component {
  render() {
    const { app, user } = this.props;
    const logoSize = app && app.xs ? 'medium' : 'big';
    return (
      <div>
        <div className="text-center">
          <Logo size={logoSize} />
        </div>
        {/* <h1 className="text-center">
          Welcome to the OnGo&trade; Certification Database
        </h1> */}
        {user && user.id ? (
          <Alert bsStyle="info">
            <strong>Please choose from the options on the menu above.</strong>
          </Alert>
        ) : (
          <div>
            <h3 style={{ padding: "15px 15vw", lineHeight: "1.5", textAlign: "center" }}>The OnGo™ Certification Database is no longer in service. Contact the OnGo Certification Body at <a href="mailto:jorg.brakensiek@ongoalliance.org">jorg.brakensiek@ongoalliance.org</a> for any new or pending OnGo certification requests.</h3>
            {/* <h3 className="home-description">
              The purpose of the OnGo&trade; certification program is to
              ensure multi-vendor interoperability of LTE equipment in the US
              3.5 GHz band.
            </h3>
            <h3 className="home-description">
              This database is for use by equipment manufacturers participating
              in the OnGo&trade; Certification Program and by CBRS Alliance
              Authorized Testing Laboratories.
            </h3>
            <div className="Login">
              <a href={createMemberLoginLink()} className="app-button-link">
                <LoaderButton
                  block
                  bsSize="large"
                  bsStyle="warning"
                  text="Login"
                />
              </a>
              <br />
            </div> */}
          </div>
        )}
        <QuickSearch history={this.props.history} />
      </div>
    );
  }
}

function mapStateToProps({ app, user }) {
  return { app, user };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js